import { IGetSearchDataResponse } from '../../types/search';
import { axiosInstance } from '../axiosInstance';

export const getSearchData = async (
  phrase: string,
): Promise<IGetSearchDataResponse> => {
  const response = await axiosInstance.get(`/search?phrase=${phrase}`);

  return response.data;
};
